import React from "react";
import Container from "../Layout/Container";
import { connect } from "react-redux";
import {
  getServices,
  getServiceRepairSms,
  serviceExportDocumentsExls,
} from "../../redux/Actions/Service/serviceAction";
import ContentBlock from "../Layout/ContentBlock";
import Pagination from "../Dashboard/items/Pagination";
import TableColumnService from "./Items/TableColumnService";
import FilterMenu from "../Layout/FilterMenu";
import TableFilterBox from "../common/TableFilterBox";
import ContentValidation from "../common/ContentValidation";
import InputText from "../orders/accepted_orders/InputFilter";
import { ButtonCenter, SelectForm } from "../common/Buttons";
import ServiceScreenAdd from "./Items/ServiceScreen_add";
import ServiceModal from "./Items/ServiceRepairModal";
import { formatDatePlus, getDateFormat } from "../../helpers/Utils";
import RangePickerComp from "../common/RangePickerComp";
import {
  status_options,
  service_type_options,
} from "../../helpers/GlobalOptions";
import { Label } from "../globals";
import { AlertError, AlertSuccess } from "../common/Alerts";
import { getSuppliersOption } from "../../redux/Actions/supplierAction";
import { get_presta_services_options } from "../../redux/Actions/prestaAction";

class ServiceScreen extends React.Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
      modalInfo: { id: 0, number: 0 },

      page: 1,
      pageCount: 100,
      paramsFilter: "",
      suppliers: [],
      filter: {
        number: "",
        type: undefined,
        client: "",
        goods: "",
        status: undefined,
        date: ["", ""],
        supplier: undefined,
        supplier_date: ["", ""],
        id_order: "",
        service_number: "",
      },
    };
    this.modalRef = React.createRef();
  }
  componentDidMount() {
    this.reloadData(this.state.paramsFilter);
    this.props.getServiceRepairSms();

    Promise.all([getSuppliersOption(), get_presta_services_options()]).then(
      (response) => {
        let newArray = [{ label: "ALL", value: "" }];
        if (response[0].data) {
          response[0].data.data.forEach((item) => {
            const findIndex = newArray.findIndex(
              (find) => find.name == item.name
            );
            if (findIndex == -1) {
              return newArray.push({
                value: item.id,
                name: item.name,
                code: item.code,
                label: item.title || item.name,
                is_code: item.is_code,
              });
            }
          });
        }
        if (response[1]) {
          response[1].forEach((d) => {
            return newArray.push({
              value: "presta_" + d.id,
              name: d.service_center,
              code: null,
              label: d.service_center + " - " + d.category,
              is_code: null,
            });
          });
        }
        this.setState({
          suppliers: newArray,
        });
      }
    );

    const paramsAction = this.props.match.params?.action;
    if (paramsAction) {
      if (paramsAction === "new") {
        this.props.history.push(`/service/repair/new`);
      } else {
        const buildNumber = +paramsAction + 100;
        this.openModal("modal", {
          id: paramsAction,
          number: "R" + buildNumber,
        });
      }
    }
  }
  componentDidUpdate(_, prevState) {
    if (
      prevState.page !== this.state.page ||
      prevState.pageCount !== this.state.pageCount
    ) {
      this.reloadData(this.state.paramsFilter);
    }
  }
  reloadData = (paramsFilter) => {
    this.props.getServices(this.state.page, this.state.pageCount, paramsFilter);
  };

  onAction = (action, index) => {
    this.setState({
      action: action,
    });
  };

  filterChange = (e, date) => {
    if (date) {
      this.setState(
        {
          filter: {
            ...this.state.filter,
            [date]: e,
          },
        },
        () => this.onFilter()
      );
    } else {
      this.setState({
        filter: {
          ...this.state.filter,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  delayOnFilter = () => {
    if (this.props.loading_store) {
      return setTimeout(() => {
        return this.delayOnFilter();
      }, 1000);
    }
    this.onFilter();
  };

  onFilter = () => {
    if (this.props.loading_store) {
      return this.delayOnFilter();
    }
    let filterParams = [];
    if (this.state.filter.number.length > 0)
      filterParams.push(`&q[number_i_cont_any]=${this.state.filter.number}`);

    if (this.state.filter.id_order)
      filterParams.push(
        `&q[order_id_order_i_cont_any]=${this.state.filter.id_order}`
      );
    if (this.state.filter.service_number)
      filterParams.push(
        `&q[service_number_i_cont_any]=${this.state.filter.service_number}`
      );
    if (this.state.filter.type)
      filterParams.push(
        `&q[service_type_i_cont_any]=${this.state.filter.type}`
      );
    if (this.state.filter.client.length > 0) {
      let clientArray = this.state.filter.client.split(" ");
      clientArray.forEach((item) => {
        filterParams.push(
          `&q[address_firstname_or_address_lastname_or_address_phone_or_address_other_cont_any]=${item}`
        );
      });
    }

    if (this.state.filter.goods.length > 0)
      filterParams.push(
        `&q[service_rows_item_name_cont]=${this.state.filter.goods}
    `
      );

    if (this.state.filter.status !== undefined) {
      this.state.filter.status.forEach((each) => {
        filterParams.push(`&q[status_in][]=${each}`);
      });
    }

    if (this.state.filter.date[0].length > 0)
      filterParams.push(`&q[created_at_gteq]=${this.state.filter.date[0]}`);

    if (this.state.filter.date[1].length > 0) {
      filterParams.push(
        `&q[created_at_lt]=${formatDatePlus(this.state.filter.date[1])}`
      );
    }
    if (this.state.filter.supplier) {
      if (this.state.filter.supplier.toString().startsWith("presta_")) {
        filterParams.push(
          `&q[service_rows_supplyings_presta_service_id_eq]=${this.state.filter.supplier.replace(
            "presta_",
            ""
          )}`
        );
      } else {
        filterParams.push(
          `&q[service_rows_supplyings_supplier_id_eq]=${this.state.filter.supplier}`
        );
      }
    }

    if (this.state.filter.supplier_date[0].length > 0)
      filterParams.push(
        `&q[service_rows_supplyings_date_gteq]=${this.state.filter.supplier_date[0]}`
      );

    if (this.state.filter.supplier_date[1].length > 0) {
      filterParams.push(
        `&q[service_rows_supplyings_date_lt]=${formatDatePlus(
          this.state.filter.supplier_date[1]
        )}`
      );
    }

    this.setState(
      {
        paramsFilter: filterParams.join(""),
      },
      () => this.reloadData(filterParams.join(""))
    );
  };
  setPagination = (page) => {
    this.setState({
      page,
    });
  };
  setPageCount = (pageCount) => {
    this.setState({
      pageCount,
      page: 1,
    });
  };

  handleKeyDown = (e) => {
    if (e.key == "Enter") {
      this.onFilter();
    }
  };

  clearFilter = () => {
    this.setState(
      {
        page: 1,
        filter: {
          number: "",
          type: undefined,
          client: "",
          goods: "",
          status: undefined,
          date: ["", ""],
          supplier: undefined,
          supplier_date: ["", ""],
          id_order: "",
          service_number: "",
        },
      },
      () => this.onFilter()
    );
  };

  renderCustomButton = () => {
    return (
      <>
        <button
          type="button"
          className="rounded-circle float-center mr-3"
          data-toggle="modal"
        >
          {"+"}
        </button>
        <ButtonCenter
          style={{ marginLeft: "5px" }}
          text={"Add a new service"}
          onClick={() => this.serviceControl(true)}
        />
        <div className="dropdown">
          <button
            className="btn btn-sm btn-dark float-right mr-3 dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Export
          </button>
          <div
            className="dropdown-menu dropdown-menu-right"
            aria-labelledby="dropdownMenuButton"
          >
            <button
              className="dropdown-item"
              onClick={() =>
                serviceExportDocumentsExls(this.state.paramsFilter)
              }
            >
              RMA report (XLS)
            </button>
          </div>
        </div>
      </>
    );
  };

  serviceControl = (action) => {
    if (action) {
      this.props.history.push(`/service/repair/new`);
    } else {
      this.props.history.push(`/service/repair`);
    }
  };

  openModal = (type, info) => {
    this.setState({
      showModal: type,
    });
    if (info) {
      this.setState({
        modalInfo: info,
      });
    }

    if (type == false) {
      this.props.history.push("/service/repair");
    } else if (type == "modal") {
      this.props.history.push(`/service/repair/${info.id}`);
    }
  };

  render() {
    console.log("COMPILE");
    return (
      <Container
        location={{
          locationName: "Service",
          locationUrl: this.props.match.url,
        }}
      >
        <AlertSuccess alertId={"service-s"} />
        <AlertError alertId={"service-e"} />
        {this.props.match.url !== "/service/repair/new" ? (
          <>
            <ContentBlock>
              <FilterMenu
                length={`${this.props.totals || 0} / ${
                  this.props.service.length || 0
                }`}
                onChangeCountPage={this.setPageCount}
                countPage={this.state.pageCount}
                text2="Services"
              />
            </ContentBlock>
            <ContentBlock containerClass={"py-1"}>
              <TableFilterBox
                clearFilter={() => this.clearFilter()}
                // extraClass="justify-content-between"
                button1={this.renderCustomButton()}
              >
                <div className="px-1">
                  <InputText
                    number="1"
                    name="number"
                    style={{
                      width: "165px",
                      fontSize: "0.75rem",
                    }}
                    placeholder="No."
                    onKeyDown={this.handleKeyDown}
                    value={this.state.filter.number}
                    onChange={(e) => this.filterChange(e)}
                  />
                </div>
                <div className="px-1">
                  <InputText
                    number="1"
                    name="service_number"
                    style={{
                      width: "165px",
                      fontSize: "0.75rem",
                    }}
                    placeholder="Service No."
                    onKeyDown={this.handleKeyDown}
                    value={this.state.filter.service_number}
                    onChange={(e) => this.filterChange(e)}
                  />
                </div>
                <div className="px-1">
                  <InputText
                    name="id_order"
                    style={{
                      width: "165px",
                      fontSize: "0.75rem",
                    }}
                    placeholder="Order No."
                    onKeyDown={this.handleKeyDown}
                    value={this.state.filter.id_order}
                    onChange={(e) => this.filterChange(e)}
                  />
                </div>
                <div
                  className="px-1"
                  style={{ width: "165px", height: "50.5px" }}
                >
                  <SelectForm
                    options={[
                      { label: "ALL", value: "" },
                      ...service_type_options,
                    ]}
                    dropdownMatchSelectWidth={false}
                    placeholder="Type"
                    value={this.state.filter.type}
                    onChange={(e) => this.filterChange(e, "type")}
                  />
                </div>

                <div className="px-1">
                  <InputText
                    number="1"
                    name="client"
                    placeholder="Client"
                    style={{
                      width: "165px",
                      fontSize: "0.75rem",
                    }}
                    onKeyDown={this.handleKeyDown}
                    value={this.state.filter.client}
                    onChange={(e) => this.filterChange(e)}
                  />
                </div>
                <div className="px-1">
                  <InputText
                    number="1"
                    name="goods"
                    placeholder="Goods"
                    style={{
                      width: "165px",
                      fontSize: "0.75rem",
                    }}
                    onKeyDown={this.handleKeyDown}
                    value={this.state.filter.goods}
                    onChange={(e) => this.filterChange(e)}
                  />
                </div>
                <div
                  className="px-1"
                  style={{ minWidth: "150px", maxWidth: "165px" }}
                >
                  <SelectForm
                    placeholder="Status"
                    mode="multiple"
                    dropdownMatchSelectWidth={false}
                    options={status_options}
                    onChange={(e) => this.filterChange(e, "status")}
                    value={this.state.filter.status}
                  />
                </div>
                <div className="px-1" style={{ width: "165px" }}>
                  <SelectForm
                    options={this.state.suppliers}
                    dropdownMatchSelectWidth={false}
                    placeholder="Services"
                    value={this.state.filter.supplier}
                    onChange={(e) => this.filterChange(e, "supplier")}
                  />
                </div>
                <div className="px-1">
                  <div className="form-group order-input-form-group">
                    <Label className="text-sm-label">Date:</Label>
                    <div>
                      <RangePickerComp
                        style={{ width: 250 }}
                        placeholder={["Start time", "End time"]}
                        value={[
                          getDateFormat(this.state.filter.date[0]),
                          getDateFormat(this.state.filter.date[1]),
                        ]}
                        onChange={(_, args) => this.filterChange(args, "date")}
                      />
                    </div>
                  </div>
                </div>
                <div className="px-1">
                  <div className="form-group order-input-form-group">
                    <Label className="text-sm-label">Service date:</Label>
                    <div>
                      <RangePickerComp
                        style={{ width: 250 }}
                        placeholder={["Start time", "End time"]}
                        value={[
                          getDateFormat(this.state.filter.supplier_date[0]),
                          getDateFormat(this.state.filter.supplier_date[1]),
                        ]}
                        onChange={(_, args) =>
                          this.filterChange(args, "supplier_date")
                        }
                      />
                    </div>
                  </div>
                </div>
              </TableFilterBox>
              <div>
                <ContentValidation
                  loader={this.props.loading}
                  array={this.props.service}
                >
                  <div className="table-responsive">
                    <table className="table table-sm table-hover mt-3">
                      <thead>
                        <tr className="text-muted">
                          <th className="text-black">Date</th>
                          <th className="text-black">No.</th>
                          <th className="text-black">Order no.</th>
                          <th className="text-black">Type</th>
                          <th className="text-black">Client</th>
                          <th className="text-black">Goods</th>
                          {/* <th className="text-black">Service date</th>
                          <th className="text-black">Services</th> */}
                          <th className="text-black">Service no.</th>
                          <th className="text-black">Tracking numbers</th>
                          <th className="text-black">Delivery</th>
                          <th className="text-black">Status</th>
                          <th className="text-black">KA comments</th>
                          <th className="text-black">Logistic comments</th>
                          <th className="text-black">Service comments</th>
                          <th className="text-black">Sum</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.service.map((item, index) => {
                          return (
                            <TableColumnService
                              key={index}
                              index={index}
                              item={item}
                              openModal={this.openModal}
                            />
                          );
                        })}
                      </tbody>
                    </table>
                    <Pagination
                      setPagination={this.setPagination}
                      page={this.state.page}
                      totals={this.props.totals}
                      pageCount={this.state.pageCount}
                    />
                  </div>
                </ContentValidation>
              </div>
            </ContentBlock>
          </>
        ) : (
          <ServiceScreenAdd onClose={this.serviceControl} />
        )}

        <ServiceModal
          showModal={this.state.showModal}
          modalInfo={this.state.modalInfo}
          closeModal={this.openModal}
        />
      </Container>
    );
  }
}
const mapStateToProps = (state) => ({
  service: state.service.service,
  totals: state.service.totals,
  loading: state.service.loading,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  getServices,
  getServiceRepairSms,
})(ServiceScreen);
